import { InputGroup, Input, InputRightElement } from "@chakra-ui/react";
import debounce from "lodash/debounce";
import { useState, useContext, useMemo, useEffect } from "react";
import { MdsSearchRound } from "react-icons-with-materialsymbols/mds";

import { Icon } from "@/design/components/icon";

import { FilterDetailsContext } from "../filter-details-context";

export const ValueSearch = () => {
  const { paginationDetails } = useContext(FilterDetailsContext)!;

  const { handleSearchChange } = paginationDetails;

  const [search, setSearch] = useState<string>("");

  const debouncedSearchFn = useMemo(() => 
    debounce((value: string) => {
      if (handleSearchChange) {
        handleSearchChange(value);
      }
    }, 500),
  [handleSearchChange]);

  useEffect(() => () => debouncedSearchFn.cancel(), [debouncedSearchFn]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearchFn(value);
  };

  return (
    <InputGroup size="md">
      <Input
        className="!rounded-[3px] !border-gray-500 placeholder-gray-500 "
        onChange={onChange}
        placeholder="Search"
        size="sm"
        value={search}
      />
      <InputRightElement boxSize="31px">
        <Icon as={MdsSearchRound} color="gray-500" size="sm" />
      </InputRightElement>
    </InputGroup>
  );
};
